const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const nilUUID = '00000000-0000-0000-0000-000000000000';
const rfc3339Pattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(Z|([+-])(\d{2}):(\d{2}))$/;

export const requireUUID = (value: unknown, message: string): string => {
  if (typeof value !== 'string' || !uuidPattern.test(value) || value === nilUUID) throw new Error(message);
  return value;
};

export const requireRFC3339 = (value: unknown, message: string): string => {
  if (typeof value !== 'string') throw new Error(message);
  const match = rfc3339Pattern.exec(value);
  if (match === null) throw new Error(message);

  const [, rawYear, rawMonth, rawDay, rawHour, rawMinute, rawSecond, fraction = '', zone, sign, rawOffsetHour, rawOffsetMinute] = match;
  const [year, month, day, hour, minute, second] = [rawYear, rawMonth, rawDay, rawHour, rawMinute, rawSecond].map(Number);
  const millisecond = Number((fraction + '000').slice(0, 3));
  const local = new Date(0);
  local.setUTCFullYear(year, month - 1, day);
  local.setUTCHours(hour, minute, second, millisecond);
  if (local.getUTCFullYear() !== year || local.getUTCMonth() !== month - 1 || local.getUTCDate() !== day
    || local.getUTCHours() !== hour || local.getUTCMinutes() !== minute || local.getUTCSeconds() !== second) {
    throw new Error(message);
  }

  let offsetMinutes = 0;
  if (zone !== 'Z') {
    const offsetHour = Number(rawOffsetHour);
    const offsetMinute = Number(rawOffsetMinute);
    if (offsetHour > 23 || offsetMinute > 59) throw new Error(message);
    offsetMinutes = (offsetHour * 60 + offsetMinute) * (sign === '+' ? 1 : -1);
  }
  if (new Date(value).getTime() !== local.getTime() - offsetMinutes * 60_000) throw new Error(message);
  return value;
};
